import {
  Descriptions,
  Button,
  Form,
  Input,
  Select,
  ConfigProvider
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import "@/views/JobRequests/Contractor/Edit.scss";
import {
  HomeOutlined,
  ExclamationCircleOutlined,
  RollbackOutlined
} from "@ant-design/icons";
import api from "@/utils/api";
import http from "@/utils/http";
import moment from "moment";
import { useNavigate, useLocation } from 'react-router-dom';
import { CustomUploadNew, CustomUploadNew2 } from "@/hocComponents";
import { majorProjectAPStatusDictFn } from "@/utils/dict";
import commonFn from "@/utils/commonFn";

export default function ContractorEdit() {
  const [propContractorId, setPropContractorId] = useState(null);
  const [detail, setDetail] = useState({});
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [filePaths, setFilePaths] = useState([]);
  const customUploadNewRef = useRef(null);

  const location = useLocation();

  const getDetailFn = async(propsId) => {
    const id = propsId || propContractorId
    const response = await http.get(api.getContractDetail, {params: {id}});
    if (response.code == 1) {
      const {contract, project} = response.data
      const list = (contract?.fileList || [])?.map(item => ({ ...item, url: item.allPath, baseUrl: item.allPath, name: item.name || item.fileName, type: item.contentType}))
      const {propId, projectName, unitId, unitName, propName, projectManger, createTime  } = project
      const {projectIdStr, contractor, expectedCompleteTime, amount, createByName, co, payAmount, contractDate, remainingAmount, commenceDate, contractedAmount, fileList, contractedOtherAmount, grandTotal } = contract
      setDetail({
        propId,
        'Project Name': projectName,
        'Project Number': projectIdStr,
        // 'Contractor Name': contractor,
        'Address': (unitId && unitId !== -1) ? unitName : propName,
        'Completion Date': moment(expectedCompleteTime).format("MM/DD/YYYY"),
        'Project Manager': projectManger,
        'Original Contract': commonFn.amountToDollarFn(amount),
        'Original Contract Temp': amount,
        'Created By': createByName,
        'Change Order': commonFn.amountToDollarFn(co),
        'Created Date': moment(createTime).format("MM/DD/YYYY"),
        'Total Paid': commonFn.amountToDollarFn(payAmount),
        'Contract Date': moment(contractDate).format("MM/DD/YYYY"),
        'Remaining': commonFn.amountToDollarFn(remainingAmount),
        'Commence Date': moment(commenceDate).format("MM/DD/YYYY"),
        'Total Contract + COs': commonFn.amountToDollarFn(contractedAmount),
        'File': fileList || [],
        'Total Other Paid': commonFn.amountToDollarFn(contractedOtherAmount),
        'Total Major Project Cost': commonFn.amountToDollarFn(grandTotal),
        'fileList': list
      })
    }
  }
  const getFileListFn = async() => {
    customUploadNewRef.current.initIsLoading(true)
    const contractId = new URLSearchParams(location.search).get('contractId')
    const foreignId = new URLSearchParams(location.search).get('foreignId')
    const response = await http.get(api.contractGetAllFile, {params: {contractId, foreignId}});
    if (response.code == 1) {
      const list = (response.data || []).map(arr => {
          return arr.reduce((pre, item) => {
              return pre.concat([{ ...item, url: item.allPath, baseUrl: item.allPath, name: item.name || item.fileName, type: item.contentType}]);
          }, []);
      });
      customUploadNewRef.current.initUpdateList(list);
    }
  }

  const [form] = Form.useForm();
  const [glacctList, setGlAcctList] = useState([]);
  
  const glAcctFun = async (propId) => {
    const response = await http.get(api.showGlAcctByChartNameId,  { params: {propId, acctType: ["E"].toString(), active: 1} });
    if (response?.code === "1") {
      setGlAcctList((response.data || [])?.map((item) => ({
        value: item.glAcct,
        label: item.glAcctTitle,
        title: item.title,
      })));
    } else {
      commonFn.modalFailedFn(response)
    }
  };

  const getDetailFn1 = async() => {
    const id = new URLSearchParams(location.search).get('foreignId')
    const response = await http.get(api.getRecordDetail, { params: {id} });
    if (response?.code === "1") {
      const { propId } = response.data
      await glAcctFun(propId)
      form.setFieldsValue({
        ...response.data,
      });
    }
    setBtnDisabled(false)
  }

  useEffect(() => {
    const id = new URLSearchParams(location.search).get('id')
    setPropContractorId(id)
    getDetailFn(id)
    getDetailFn1()
    getFileListFn()
  }, [])

  const mainContractDocFn = () => {
    const list = [
      'Project Number',
      // 'Contractor Name',
      'Completion Date',
      'Address',
      'Original Contract',
      'Project Manager',
      'Change Order',
      'Created By',
      'Total Contract + COs',
      'Created Date',
      'Total Paid',
      'Contract Date',
      'Remaining',
      'Commence Date',
      'Total Other Paid',
      'Total Major Project Cost',
     ]
    const items =  list.map(item => {
      if(item === 'Created By'){
        const arr = detail?.[item]?.split(/,(.+)/)
        const str1 = arr?.[0]
        const str2 = arr?.[1]
        const result = arr?.length && (
          <>
            <div>{str1}</div>
            {str2 && <div>{str2}</div> || null}
          </>
        )
        return {
          label: item,
          children: result,
        }
      }
      return {
        label: item,
        children: detail?.[item] || null,
      }
    })
    return (
      <Descriptions 
        title={`Major Project: ${detail?.['Project Name'] || ''}`}
        className="contractorDescriptions"
        size="small"
        column={2}
        items={items} 
      />
    )
  }

  return (
    <div className="ContractorEdit">
      <div className="title">
        {new URLSearchParams(location.search).get('projectName')}
        </div>
      <div className="content" style={{display: 'flex'}}>
        <div className="mainAndSub" style={{flex: 3}}>
          <div className="main">
            {mainContractDocFn()}
          </div>
          <div className="sub">
            <Form
              form={form}
              layout="horizontal"
              labelCol={{span: 6}}
              wrapperCol={{span: 18}}
              labelWrap={true}
              labelAlign="right"
              validateMessages={{
                required: "${label} is required!",
              }}
            >
              <div
                style={{
                  marginTop: "16px",
                  marginBottom: "16px",
                  fontWeight: "bold",
                  fontSize: "20px",
                }}
              >
                <HomeOutlined style={{ marginRight: "8px" }} />
                Payment Request
              </div>
              
              <ConfigProvider componentDisabled={true}>
                {commonFn.formInputNumberDoc({
                  form,
                  label: "Amount",
                  disabled: true,
                  allowNegative: false
                })}

                <Form.Item
                  name="invoiceNumber"
                  label="Invoice #"
                  rules={[{ required: true, message: 'Invoice # is required!' }]}
                >
                  <Input
                    placeholder="Please input Invoice #"
                  />
                </Form.Item>

                <Form.Item
                  name="glAcct"
                  label="Expense GL Account"
                  rules={[{ required: true, message: 'Expense GL Account is required!' }]}
                >
                  <Select
                    showSearch
                    placeholder="Select a type"
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    options={glacctList}
                  />
                </Form.Item>

                <Form.Item
                  name="recordType"
                  label="Payment Type"
                  rules={[{ required: true, message: 'Payment Type is required!' }]}
                >
                  <Select
                    showSearch
                    placeholder="Select a type"
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    options={[
                      {
                        label: 'Major Project',
                        value: 1
                      },
                      {
                        label: 'Other Payment',
                        value: 2
                      }
                    ]}
                  />
                </Form.Item>

                <Form.Item
                  name="remark"
                  label="Remark"
                >
                  <Input.TextArea
                    placeholder="Please input Remark"
                    autoSize={{ minRows: 3, maxRows: 10 }}
                  />
                </Form.Item>
              </ConfigProvider>
            </Form>
          </div>
        </div>
        <div className="trade" style={{flex: 6}}>
          <CustomUploadNew2
            ref={(el) => (customUploadNewRef.current = el)}
            customConfig={{
              pdfHeight: "76vh",
              notMultiple: true,
              accept: ".jpg, .jpeg, .png, .pdf",
              status: 'add',
              disabled: true,
              noUploadBtn: true
            }}
            setFilePaths={setFilePaths} 
            filePaths={filePaths} 
            setBtnDisabled={setBtnDisabled}
            btnDisabled={btnDisabled}
          />
        </div>
      </div>
    </div>
  );
}
